import React, {Fragment, useEffect, useState} from "react";
import {IRound} from "../_interfaces/IRound";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {CircularProgress, List, ListItem, Typography} from "@mui/material";
import TextField from "@mui/material/TextField";
import SearchIcon from '@mui/icons-material/Search';
import CheckIcon from "@mui/icons-material/Check";
import IconButton from "@mui/material/IconButton";
import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {IChar} from "../_interfaces/IChar";
import defaultChar from "../_helper/defaultChar";
import {v4} from "uuid";
import {IRoundCharacters} from "../_interfaces/IRoundCharacters";
import StartIcon from '@mui/icons-material/Start';
type Props = {
    startRound: (rid: string, char: IChar | undefined) => void
}
export default function PC({startRound}: Props) {

    const [loading, setloading] = useState(false)

    const [GMEmail, setGMEmail] = useState(''); // email

    const [roundCharacters, setRoundCharacters] = useState<IRoundCharacters[]>([])

    const [rounds, setRounds] = useState<IRound[]>([])
    const [chars, setchars] = useState<IChar[]>([])

    const [round, setRound] = useState('')
    const [char, setChar] = useState('')

    useEffect(() => {
        const lsChar = localStorage.getItem('char')
        setChar(lsChar ?? '');
        if (chars.length === 0) fetchChars()
        if (roundCharacters.length === 0) fetchCharacterRounds()
    }, [])

    const fetchChars = () => {
        fetch(apiAddress + "/users/chars", createOptions('GET'))
            .then((res) => res.json()).then((data) => {
            if (data.hasOwnProperty('chars')) {
                setchars(data.chars);
            }
        })
    }

    const fetchCharacterRounds = () => {
        fetch(apiAddress + "/rounds/chars", createOptions('GET'))
            .then((res) => res.json()).then((data) => {
            if (data.hasOwnProperty('round_characters')) {
                setRoundCharacters(data.round_characters);
            }
        })
    }

    const newChar = () => {
        const nchar: IChar = {
            ...defaultChar,
            id: v4()
        }
        fetch(apiAddress + "/chars/create", createOptions('POST', {
            id: nchar.id,
            nsc: false,
            visible: true
        }))
            .then((res) => {
                console.log('newChar', res.status)
                if (res.status === 200) setchars(prev => [...prev, nchar])

            });
    }

    const findGM = () => {
        fetch(apiAddress + "/users/findgm/" + GMEmail, createOptions('GET'))
            .then((res) => res.json()).then((data) => {
            console.log('findGM by email', data);
            if (data.hasOwnProperty('user') && Array.isArray(data.user) && data.user.length > 0) {
                findRounds(data.user[0]);
            }
        })
    }

    const findRounds = (foundGM: string) => {
        fetch(apiAddress + "/rounds/find/" + foundGM, createOptions('GET'))
            .then((res) => res.json()).then((data) => {
            console.log('findRounds by gm uid', foundGM, data)
            setRounds(data.rounds)
        })
    }

    const joinRound = (rid: string, cid: string) => {
        fetch(apiAddress + "/rounds/join/" + rid + '/' + cid, createOptions('GET'))
            .then((res) => res.json()).then((data) => {
            setloading(false);
            if (data.hasOwnProperty('round_characters')) {
                setRoundCharacters(data.round_characters);
                localStorage.setItem('round', rid);
            }
        })
    }

    const roundCharacterRow = (rc: IRoundCharacters) => {
        return <ListItem disablePadding key={rc.id}>
            <Grid container spacing={1} style={{margin: 10,backgroundColor:'#f8f4f4',padding:'0 0 6px 0',borderRadius:4}}>
                <Grid item xs={4}>Runde: {rc.rname}</Grid>
                <Grid item xs={4}>Charakter: {rc.cname ? rc.cname : 'kein name??'}</Grid>
                <Grid item xs={1}>
                    <IconButton onClick={() => startRound(rc.rid, chars.find(c => c.id === rc.cid))}>
                        <StartIcon/>
                    </IconButton>
                </Grid>
                {rc.rdescription ?
                    <Grid item xs={12} style={{marginLeft: 12, fontStyle: 'italic'}}>{rc.rdescription}</Grid> : null}
            </Grid>
        </ListItem>
    }

    const roundRow = (r: IRound) => {
        return (<ListItem disablePadding key={r.id}>
            <Grid container spacing={1} style={{padding: 10}}>
                <Grid item xs={4}>{r.name}</Grid>
                <Grid item xs={1}>
                    {round === r.id ? 'aktiv' :
                        <IconButton sx={{marginTop: '0!important'}} onClick={() => setRound(r.id)}>
                            <CheckIcon></CheckIcon></IconButton>
                    }
                </Grid>
                {r.description ?
                    <Grid item xs={12} style={{marginLeft: 12, fontStyle: 'italic'}}>{r.description}</Grid> : null}
            </Grid>
        </ListItem>)
    }

    const charRow = (c: IChar) => {
        return (<ListItem disablePadding key={c.id}>
            <Grid container spacing={1} style={{padding: 10}}>
                <Grid item xs={5}>{c.name ? c.name : 'kein Name ID: ' + c.id}</Grid>
                <Grid item xs={2}>
                    {char === c.id ? 'aktiv' :
                        <IconButton sx={{marginTop: '0!important'}} onClick={() => setChar(c.id)}>
                            <CheckIcon></CheckIcon>
                        </IconButton>}
                </Grid>
            </Grid>
        </ListItem>)
    }

    const gmFindForm = () => {
        return (<div style={{marginLeft: 12}}>
            <TextField onChange={e => setGMEmail(e.target.value)}
                       value={GMEmail}
                       variant="standard"
                       label="GMEmail:"/>
            <IconButton disabled={GMEmail === ''} onClick={() => findGM()}>
                <SearchIcon></SearchIcon>
            </IconButton>
        </div>)
    }

    return <Fragment>
        {loading ? <CircularProgress></CircularProgress> : null}
        <Paper style={{marginBottom: 6}}>
            <Typography variant="h6" style={{padding: 10}} gutterBottom>Charaktere in Runden</Typography>
            <List>
                {roundCharacters.map(r => roundCharacterRow(r))}
            </List>
        </Paper>
        {round !== '' && char !== '' ?
            <Paper style={{marginBottom: 6}}>
                <Button onClick={() => joinRound(round, char)}>
                    Beitreten (Charakter: {chars.find(c => c.id == char)?.name ?? 'kein Name'}
                    /
                    Runde: {rounds.find(c => c.id == round)?.name})
                </Button>
            </Paper> : null}

        <Paper style={{marginBottom: 6}}>
            <Typography variant="h6" style={{padding: 10}} gutterBottom>Runden</Typography>
            {gmFindForm()}
            <List>
                {rounds.map(r => roundRow(r))}
            </List>
        </Paper>

        <Paper>
            <Typography variant="h6" style={{padding: 10}} gutterBottom>Charaktere</Typography>
            <List>
                {chars.map((c) => charRow(c))}
            </List>
            <Button onClick={() => newChar()}>Neuer Charakter</Button>
        </Paper>
    </Fragment>
}
